import { ReactComponent as UploadSuccess } from 'assets/upload-success.svg';
import { ReactComponent as RemoveBtn } from 'assets/remove-btn.svg';
import PropTypes from 'prop-types';
import './ThumbnailItem.scss';

const ThumbnailItem = ({
  file,
  onRemove,
  onPreview,
  uploading,
  showProgress,
  specifiedSize
}) => {
    const handlePreview = (e) => {
        if (e.target.closest('.thumb-remove-btn')) {
            return;
        }
        if (onPreview) {
            onPreview(file);
        }
    };

    return (
        <div className="thumbnail-item">
            <div
                className={`thumbnail-wrapper
                    ${onPreview ? 'clickable' : ''}
                    ${specifiedSize ? 'size-medium' : ''}
                `}
                onClick={handlePreview}
            >
                <img
                    src={file.thumbnailUrl}
                    alt={file.name}
                    className="thumbnail-img"
                />

                {showProgress && (file.status === 'uploading' || file.status === 'compressing') && (
                    <div
                        className="masking-progress"
                        style={{
                            background: `linear-gradient(to right,
                                transparent 0%,
                                transparent ${file.progress || 0}%,
                                rgba(255, 255, 255, 0.5) ${file.progress || 0}%,
                                rgba(255, 255, 255, 0.5) 100%)`
                        }}
                    >
                        <span className="masking-progress-text">{file.progress || 0}%</span>
                    </div>
                )}
                {onRemove && file.status !== 'uploaded' && !uploading && (
                    <button
                        onClick={() => onRemove(file.id)}
                        className="thumb-remove-btn"
                    >
                        <RemoveBtn />
                    </button>
                )}
                {showProgress && (file.status === 'uploaded') && (
                    <div className="upload-success">
                        <UploadSuccess />
                    </div>
                )}
            </div>
        </div>
    );
};

ThumbnailItem.propTypes = {
    file: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string,
        thumbnailUrl: PropTypes.string.isRequired,
        status: PropTypes.string,
        progress: PropTypes.number,
    }).isRequired,
    onRemove: PropTypes.func,
    onPreview: PropTypes.func,
    uploading: PropTypes.bool,
    showProgress: PropTypes.bool,
    specifiedSize: PropTypes.bool,
};

ThumbnailItem.defaultProps = {
    onRemove: null,
    onPreview: null,
    uploading: false,
    showProgress: false,
    specifiedSize: false,
};

export default ThumbnailItem;
